import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CiLocationOn } from 'react-icons/ci'
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6'
import { PiUsersThreeLight } from 'react-icons/pi'
import { FaRegCalendarAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../store'
import { setDates } from '../../../features/home/bookingSlice'
import toast from 'react-hot-toast'
import SearchInput from '../SearhInput'
import { durationOptions, peopleRanges } from '../../../constants/data'

const HallForm = () => {
    const { t, i18n } = useTranslation()
    const [destination, setDestination] = useState("")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [amount, setAmount] = useState<number>()
    const [checkIn, setCheckIn] = useState<Date>();
    const [duration, setDuration] = useState<1 | 2>(1);
    const [minPeople, setMinPeople] = useState<number | null>(null);
    const [maxPeople, setMaxPeople] = useState<number | null>(null);
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault()

        if (!destination) return toast.error(t("destination_required"))
        if (!checkIn) {
            return toast.error(`• ${t("requiredDates")}`);
        }
        if (!minPeople || !maxPeople) return toast.error(t("please_select_people"))
        const params = new URLSearchParams()
        params.append("destination", destination)
        if (amount) params.append("amount", String(amount))
        if (checkIn && duration) {
            const checkInDate = new Date(checkIn);

            params.append("checkIn", checkInDate.toISOString());
            params.append("duration", String(duration));

            dispatch(setDates({ checkIn: checkInDate, duration: duration }));
        }
        if (minPeople !== null) params.append("minNumberOfPeoples", String(minPeople));
        if (maxPeople !== null) params.append("maxNumberOfPeoples", String(maxPeople));

        navigate(`/hall-search-result?${params.toString()}`);
    }

    return (
        <div className={`px-3 rounded-b-lg ${i18n.language === "ar" ? "rounded-tl-lg" : "rounded-tr-lg"}`}>
            <form onSubmit={handleSearch} className="grid xs:grid-cols-2 md:grid-cols-5 items-end py-8 gap-2">
                <div >
                    <SearchInput
                        value={destination}
                        type="text"
                        onChange={setDestination}
                        placeholder={t("destination-placeholder")}
                        label={t("destination-label")}
                        icon={<CiLocationOn />}
                    />
                </div>
                <div >
                    <SearchInput
                        type="select"
                        icon={<PiUsersThreeLight size={20} />}
                        label={t("amount-label")}
                        options={[
                            {
                                label_ar: "اختر عدد الأشخاص",
                                label_en: "Select people range",
                                value: "",
                            },
                            ...peopleRanges,
                        ]}
                        value={minPeople !== null ? `${minPeople}-${maxPeople}` : ""}
                        onChange={(val: string) => {
                            const [min, max] = val.split("-");
                            setMinPeople(Number(min));
                            setMaxPeople(max === "null" ? null : Number(max));
                        }}
                    />
                </div>
                {/* Check In */}
                <div className=''>
                    <SearchInput
                        value={checkIn}
                        type="date"
                        onChange={setCheckIn}
                        placeholder={t("checkin-placeholder")}
                        label={t("checkin-label")}
                        icon={<FaRegCalendarAlt />}
                    />
                </div>
                {/* Check Out */}
                <div className=''>
                    <SearchInput
                        value={duration}
                        type="select"
                        onChange={setDuration}
                        label={t("duration-label")}
                        options={durationOptions}
                    />
                </div>

                <button
                    type="submit"
                    className="flex-center h-fit gap-2 px-4 py-2 bg-primary text-white rounded-lg "
                >
                    {t("search")}
                    {i18n.language === "ar" ? <FaArrowLeftLong /> : <FaArrowRightLong />}
                </button>
            </form>
        </div>
    )
}

export default HallForm
